<template>
  <div class="journey-overview">
    <h1>{{title}}</h1>
    <span class="label"> {{ $t('message.learner-journey') }}</span>
    <div class="gray-tile started" v-if="started" :started="started">
      <JourneyMetadata :duration="duration"></JourneyMetadata>
      <a
        v-if="!assigned"
        href=""
        :class="`${loading ? 'disabled' : ''}`"
        @click.prevent="unenroll"
        @keyup.enter.prevent="unenroll">
          {{ $t('message.remove-from-active-journeys') }}
      </a>
    </div>
    <div class="enroll blue-block" v-else>
      <span> {{ $t('message.starting-a-learner-journey') }} </span>
      <p>{{ $t('message.learner-journey-info') }}</p>
      <button
        @click="enroll"
        @keyup.enter="enroll"
        :disabled="loading"
        class="link-button">
          {{ $t('message.start-journey') }}
          <RightArrow
          :opacity="1"
          fill="white">
          </RightArrow>
      </button>
    </div>
    <JourneyMedia v-if="media" :media="media"></JourneyMedia>
    <div class="description" v-html="description"></div>
  </div>
</template>

<style lang="less" scoped>
  @import "./shared.less";
  div.journey-overview::-webkit-scrollbar {
    width: 0px;
  }
  .journey-overview {
    position: relative;
    padding: 30px;
    h1{
      line-height: 120%;
    }
    .view, a {
      cursor: pointer;
      text-decoration: underline;
      color: white;
    }
    a {
      line-height: 2em;
      &.disabled {
        cursor: progress;
      }
    }
    .label {
      display: block;
      margin-bottom: 45px;
    }
    .description::v-deep {
      margin-top: 20px;
      min-height: calc(100% - 180px);
      line-height: 145%;
      padding-bottom: 180px;
      strong{
        font-weight: bold;
      }
      em{
        font-style: italic;
      }
      p{
        color: #FFF;
        padding-bottom: 0.75em;
        padding-top: 0.75em;
      }
      a{
        text-decoration: underline;
        color: #FFF
      }
      ol{
        padding-left: 20px;
      }
      ul{
        list-style: disc;
        padding-left: 20px;
      }
      li{
        color: #FFF;
        padding-bottom: 0.75em;
        padding-top: 0.75em;
        p{
          padding-top: 0px;
          padding-bottom: 0px;
        }
      }
    }
    button {
      background: #0064c8;
      color: white;
      cursor: pointer;
      -webkit-transition: background 0.2s ease-out;
      transition: background 0.2sease-out;
      &:hover:not(:disabled) {
        background: darken(#0064c8, 7%);
      }
      &:disabled {
        cursor: progress;
      }
    }
    .blue-block {
      color: white;
      padding: 20px 20px 8px 20px;
      border-radius: 8px;
      span {
        color: white;
        font-weight: 600;
      }
      p {
        color: white;
        margin-top: 10px;
      }
    }
  }
</style>

<script>
import { mapActions, mapGetters } from "vuex";
import JourneyMetadata from "@/journeys/JourneyMetadata";
import RightArrow from "@/common/icons/RightArrow";
import { track } from "swetrix";
import JourneyMedia from "./JourneyMedia.vue";


export default {
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters(["currentUser", "currentEdition"])
  },
  components: {JourneyMetadata, RightArrow, JourneyMedia},
  props: ['journeyId', 'title', 'media', 'duration', 'description', 'started', 'assigned'],
  methods: {
    async unenroll () {
      if (this.loading) { return; }
      this.loading = true;
      await this.leaveSelectedJourney();
      this.loading = false;

      track({
        ev: "journey_unenrolled",
        meta: {
          journeyId: String(this.journeyId),
          journeyTitle: String(this.title),
          userId: String(this.currentUser.id),
          editionId: String(this.currentEdition.id),
          location: "journey_overview"
        }
      });
    },
    async enroll () {
      if (this.loading) { return; }
      this.loading = true;
      await this.startSelectedJourney();
      this.loading = false;
      this.$emit("updateEnrollment", true);

      track({
        ev: "journey_enrolled",
        meta: {
          journeyId: String(this.journeyId),
          journeyTitle: String(this.title),
          userId: String(this.currentUser.id),
          editionId: String(this.currentEdition.id),
          location: "journey_overview"
        }
      });
    },
    ...mapActions(["startSelectedJourney", "leaveSelectedJourney"])
  }
}
</script>
